import { Provider, ErrorBoundary } from "@rollbar/react";
import { rollbarConfig } from "./utils";

export function RollbarProvider({ children }) {
  return (
    <Provider config={rollbarConfig}>
      <ErrorBoundary>{children}</ErrorBoundary>
    </Provider>
  );
}
